export enum APIScope {
  // The value is used in the URL
  // Naming patern should be object_verb

  SUPER_ADMIN_ONLY = "super-admin-only",

  LOCAL_ONLY = "local-only",

  LOGGED_IN = "logged-in",
  ROLES_GET = "roles-get", // This needs to always be allowed.
  ROLES_SET = "roles-set",
  ROLES_VIEW = "roles-view",

  USER_CRM_VIEW = "user-crm-view",
  USER_CRM_WRITE = "user-crm-write",

  APPS_EDIT = "apps-edit",

  MEMBERS_GET = "members-get",
  MEMBERS_SET = "members-set",

  LOCATIONS_ALL_VIEW = "locations-all-view",
  LOCATION_VIEW = "location-view", // For a specific location

  LOCATION_CREATE = "location-create",

  LOCATION_DETAILS_READ = "location-details-read",
  LOCATION_DETAILS_WRITE = "location-details-write",

  WORKFLOWS_VIEW = "workflows-view",
  WORKFLOWS_EDIT = "workflows-edit",

  FMS_EDIT = "fms-edit",
  FMS_VIEW = "fms-view",

  CONVERSATION_VIEW = "conversation-view",
  CONVERSATION_TAKEOVER = "conversation-takeover",

  SEQUENCES_EDIT = "sequences-edit",
  SEQUENCES_VIEW = "sequences-view",

  ESCALATIONS_EDIT = "escalations-edit",
  ESCALATIONS_HANDLE = "escalations-handle",

  REVIEWS_EDIT = "reviews-view",
}
export const LimitToLocationScopes = [APIScope.LOCATION_VIEW]; // This means that if any item is true in scope then this is a true permission.

export enum APIScopeGroup { // A list of all posible API actons
  // LOGGED_IN = "logged-in",
  ROLES = "roles",
}

export enum APIScopePermission {
  ALLOWED = "allowed",
  FORBIDDEN = "forbidden",
  INHERITED = "inherited",
}

export type APIScopePermissionMap = { [action in APIScope]?: APIScopePermission };

export const AllAPIScopePermissions: { [action in APIScope]: APIScopePermission } = {
  [APIScope.SUPER_ADMIN_ONLY]: APIScopePermission.ALLOWED,
  [APIScope.LOCAL_ONLY]: APIScopePermission.ALLOWED,
  [APIScope.LOGGED_IN]: APIScopePermission.ALLOWED,

  [APIScope.ROLES_GET]: APIScopePermission.ALLOWED,
  [APIScope.ROLES_SET]: APIScopePermission.ALLOWED,
  [APIScope.ROLES_VIEW]: APIScopePermission.ALLOWED,
  [APIScope.USER_CRM_VIEW]: APIScopePermission.ALLOWED,
  [APIScope.USER_CRM_WRITE]: APIScopePermission.ALLOWED,
  [APIScope.APPS_EDIT]: APIScopePermission.ALLOWED,
  [APIScope.MEMBERS_GET]: APIScopePermission.ALLOWED,
  [APIScope.MEMBERS_SET]: APIScopePermission.ALLOWED,
  [APIScope.LOCATIONS_ALL_VIEW]: APIScopePermission.ALLOWED,
  [APIScope.LOCATION_VIEW]: APIScopePermission.ALLOWED,
  [APIScope.LOCATION_CREATE]: APIScopePermission.ALLOWED,
  [APIScope.LOCATION_DETAILS_READ]: APIScopePermission.ALLOWED,
  [APIScope.LOCATION_DETAILS_WRITE]: APIScopePermission.ALLOWED,
  [APIScope.WORKFLOWS_VIEW]: APIScopePermission.ALLOWED,
  [APIScope.WORKFLOWS_EDIT]: APIScopePermission.ALLOWED,
  [APIScope.FMS_EDIT]: APIScopePermission.ALLOWED,
  [APIScope.FMS_VIEW]: APIScopePermission.ALLOWED,
  [APIScope.CONVERSATION_VIEW]: APIScopePermission.ALLOWED,
  [APIScope.CONVERSATION_TAKEOVER]: APIScopePermission.ALLOWED,
  [APIScope.ESCALATIONS_EDIT]: APIScopePermission.ALLOWED,
  [APIScope.ESCALATIONS_HANDLE]: APIScopePermission.ALLOWED,
  [APIScope.REVIEWS_EDIT]: APIScopePermission.ALLOWED,

  [APIScope.SEQUENCES_EDIT]: APIScopePermission.ALLOWED,
  [APIScope.SEQUENCES_VIEW]: APIScopePermission.ALLOWED,
};
